import { Http } from '../Utils/Http';
import { AxiosResponse } from 'axios';
import { IAutodeskViewer } from './interfaces/Viewer/IAutodeskViewer';
import { ViewerEngineEnum } from './enums/ViewerEngine';
import { IRequestFileInfo } from './interfaces/Viewer/IGetFileInfo';
import { IUpdateStatusInViewer } from './interfaces/ListagemArquivos/IUpdateStatusInViewer';
import { IBaseResponse } from './interfaces/BaseResponse';
import { IRenderQuotaResponse } from './interfaces/Viewer/IRenderQuota';
import {
  INativeViewerArtifacts,
  IRenderViewerResponse,
  IRequestNativeViewerArtifacts,
} from './interfaces/Viewer/INativeViewerArtifacts';

export class ViewerApi {
    // `/Viewer/AutodeskViewer` é só um apelido obsoleto do Render no backend.
    static async RenderAutoDesk(file: IAutodeskViewer): Promise<AxiosResponse<any>> {
      return ViewerApi.renderViewerFile({ ...file, engine: ViewerEngineEnum.Autodesk });
    }

    static async renderViewerFile(
      request: IAutodeskViewer,
    ): Promise<AxiosResponse<IBaseResponse<IRenderViewerResponse>>> {
      const axios = await Http.axios(false);
      return axios.post(`/Viewer/Render`, {
        constructionSiteId: request.constructionSiteId,
        fileApiId: request.fileApiId,
        engine: request.engine,
      });
    }

    // Mesma conta da trava do Render; só a Autodesk gasta essa cota.
    static async getRenderQuota(fileName: string): Promise<AxiosResponse<IBaseResponse<IRenderQuotaResponse>>> {
      const axios = await Http.axios(false);
      return axios.get('/Viewer/RenderQuota', { params: { fileName } });
    }

    // Único endpoint que devolve URL assinada dos artefatos do render nativo. 403
    // quando o usuário não tem acesso à obra — o backend valida antes de assinar.
    static async getNativeArtifacts(
      request: IRequestNativeViewerArtifacts,
    ): Promise<AxiosResponse<IBaseResponse<INativeViewerArtifacts>>> {
      const axios = await Http.axios(false);
      return axios.get('/v2/viewer-artifacts', {
        params: {
          constructionSiteId: request.constructionSiteId,
          fileApiId: request.fileApiId,
        },
      });
    }

    static async GetFileInfo(request: IRequestFileInfo): Promise<AxiosResponse<any>> {
      const axios = await Http.axios(false);
      return axios.get(`/Viewer/GetFileInfo?fileApiId=${request.FileApiId}&constructionSiteId=${request.ConstructionSiteId}${request.breadCrumbId ? `&breadCrumbId=${request.breadCrumbId}` : ''}`);
    }

    static async listDisciplines(csId: number): Promise<AxiosResponse<any>> {
      const axios = await Http.axios();
      return axios.get(`/Viewer/ListDisciplines?csId=${csId}`);
    }

    static async listFiles(constructionSiteDisciplineId: number): Promise<AxiosResponse<any>> {
      const axios = await Http.axios();
      return axios.get(`/Viewer/ListFiles?constructionSiteDisciplineId=${constructionSiteDisciplineId}`);
    }

    static async updateStatusInViewer(request: IUpdateStatusInViewer): Promise<AxiosResponse<any>> {
      const axios = await Http.axios();
      return axios.put(`/Viewer/UpdateFileInViewerStatus`, request);
    }

    static async GetAccessToken(): Promise<AxiosResponse<any>> {
      const axios = await Http.axios(false);
      return axios.get(`/Viewer/GetAutoDeskAccessToken`);
    }

    static async GetManifest(accessToken: string, urn: string): Promise<AxiosResponse<any>> {
      const axios = await Http.getAxiosForge(accessToken);
      return axios.get(`/${urn}/manifest`);
    }

    static async GetAllHierarchy(accessToken: string, urn: string, guiId: string): Promise<AxiosResponse<any>> {
      const axios = await Http.getAxiosForge(accessToken);
      return axios.get(`/${urn}/metadata/${guiId}?forceget=true`);
    }

    static async GetMetadata(accessToken: string, urn: string): Promise<AxiosResponse<any>> {
      const axios = await Http.getAxiosForge(accessToken);
      return axios.get(`/${urn}/metadata`);
    }

    static async GetHierarchy(accessToken: string, urn: string, guiId: string): Promise<AxiosResponse<any>> {
      const axios = await Http.getAxiosForge(accessToken);
      return axios.get(`/${urn}/metadata/${guiId}`);
    }

    static async GetProperties(accessToken: string, urn: string, guiId: string): Promise<AxiosResponse<any>> {
      const axios = await Http.getAxiosForge(accessToken);
      return axios.get(`/${urn}/metadata/${guiId}/properties`);
    }
}
